// 3rd Party
import 'bootstrap/js/dist/collapse';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
library.add(
    faChevronDown,
    faChevronRight
);
dom.watch();

$('.wm-content--faqs .collapse-link').click(function () {
    $(this).find('svg').toggleClass('fa-chevron-right fa-chevron-down');
});